import { useFormat, useI18n, type MessageKey } from '@/i18n'
import type { Grams } from '@/lib/weight'
import type { Refusal } from '../model/rules'
import { formatBp } from '../model/balance'

/** Refusal → "हिंदी · English" (the phone shows both, as the spec writes them). */
export function useRefusal() {
  const { pair } = useI18n()
  return (r: Refusal, vars?: Record<string, string | number>) => {
    const p = pair(`process.refusal.${r}` as MessageKey, vars)
    return `${p.hi} · ${p.en}`
  }
}

/** Bilingual text of any key as one string (scanner refusals, toasts). */
export function useBoth() {
  const { pair } = useI18n()
  return (k: MessageKey, vars?: Record<string, string | number>) => {
    const p = pair(k, vars)
    return p.hi === p.en ? p.en : `${p.hi} · ${p.en}`
  }
}

/** "12.345 kg · 3.10%" */
export function useKgPct() {
  const fmt = useFormat()
  return (g: Grams, bp: number | null) => (bp === null ? fmt.weight(g) : `${fmt.weight(g)} · ${formatBp(bp)}`)
}
